"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Card = _interopRequireDefault(require("./Card.style"));
var _CardTitle = _interopRequireDefault(require("./CardTitle"));
var _Caption = _interopRequireDefault(require("./Caption"));
var _CustomMenuList = _interopRequireDefault(require("../misc/CustomMenuList"));
var _excluded = ["title", "customTitle", "subtitle", "titleProps", "delimiterProps", "children", "caption", "captionPosition", "link", "cta", "contextualMenu"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var renderCaption = function renderCaption(caption, captionPosition, otherProps) {
  if (captionPosition === 'both') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Caption["default"], _extends({
      caption: caption
    }, otherProps, {
      captionPosition: "top"
    })), /*#__PURE__*/_react["default"].createElement(_Caption["default"], _extends({
      caption: caption
    }, otherProps, {
      captionPosition: "bottom-card"
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_Caption["default"], _extends({
    caption: caption
  }, otherProps, {
    captionPosition: captionPosition === 'top' ? 'top' : 'bottom-card'
  }));
};
var Card = function Card(_ref) {
  var title = _ref.title,
    customTitle = _ref.customTitle,
    subtitle = _ref.subtitle,
    titleProps = _ref.titleProps,
    delimiterProps = _ref.delimiterProps,
    children = _ref.children,
    caption = _ref.caption,
    captionPosition = _ref.captionPosition,
    link = _ref.link,
    cta = _ref.cta,
    contextualMenu = _ref.contextualMenu,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], _extends({
    cta: cta,
    captionPosition: captionPosition
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-header"
  }, contextualMenu && /*#__PURE__*/_react["default"].createElement(_CustomMenuList["default"], {
    menuConfig: contextualMenu,
    className: "contextual-menu"
  }), title && /*#__PURE__*/_react["default"].createElement(_CardTitle["default"], _extends({
    className: "card-title",
    title: title,
    titleProps: titleProps,
    delimiterProps: delimiterProps,
    withSubtitle: !(0, _utils.isBlank)(subtitle)
  }, otherProps)), customTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-title"
  }, customTitle)), link && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-link"
  }, link), subtitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-subtitle"
  }, subtitle), children, cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-cta"
  }, cta), caption && renderCaption(caption, captionPosition, otherProps));
};
Card.defaultProps = {
  className: 'Card',
  title: '',
  subtitle: '',
  caption: '',
  children: undefined,
  titleProps: {
    id: '',
    titleFontSize: '',
    isBold: true,
    isUppercase: false,
    textTransform: 'capitalize'
  },
  delimiterProps: {
    titleDelimiter: false,
    position: 'left',
    topMargin: '',
    type: 'small'
  },
  link: '',
  cta: undefined,
  captionPosition: 'bottom',
  contextualMenu: '',
  customTitle: ''
};
Card.propTypes = {
  captionPosition: _propTypes["default"].oneOf(['top', 'bottom', 'both']),
  className: _propTypes["default"].string,
  /* The card cta button(or whatever) */
  cta: _propTypes["default"].node,
  /** Text or html to be displayed inside the card */
  children: _propTypes["default"].node,
  /**
   * A text to be displayed at the bottom of the card containing some captions
   * (eg. required fields)
   * */
  caption: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** A text to be displayed as the card title */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Attributes for the card title */
  titleProps: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    titleFontSize: _propTypes["default"].string,
    isBold: _propTypes["default"].bool,
    isUppercase: _propTypes["default"].bool,
    textTransform: _propTypes["default"].oneOf(['none', 'capitalize', 'uppercase', 'lowercase'])
  }),
  /** Attributes for the delimiter */
  delimiterProps: _propTypes["default"].shape({
    titleDelimiter: _propTypes["default"].bool,
    position: _propTypes["default"].string,
    topMargin: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['small', 'medium'])
  }),
  /** A text to be displayed as the card subtitle */
  subtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /* The card link button */
  link: _propTypes["default"].node,
  contextualMenu: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].shape({})), _propTypes["default"].node]),
  customTitle: _propTypes["default"].node
};
Card.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Card",
  "props": {
    "className": {
      "defaultValue": {
        "value": "'Card'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A text to be displayed as the card title",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "subtitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A text to be displayed as the card subtitle",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "caption": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A text to be displayed at the bottom of the card containing some captions\r\n(eg. required fields)",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Text or html to be displayed inside the card",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "titleProps": {
      "defaultValue": {
        "value": "{\r\n  id: '',\r\n  titleFontSize: '',\r\n  isBold: true,\r\n  isUppercase: false,\r\n  textTransform: 'capitalize',\r\n}",
        "computed": false
      },
      "description": "Attributes for the card title",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "titleFontSize": {
            "name": "string",
            "required": false
          },
          "isBold": {
            "name": "bool",
            "required": false
          },
          "isUppercase": {
            "name": "bool",
            "required": false
          },
          "textTransform": {
            "name": "enum",
            "value": [{
              "value": "'none'",
              "computed": false
            }, {
              "value": "'capitalize'",
              "computed": false
            }, {
              "value": "'uppercase'",
              "computed": false
            }, {
              "value": "'lowercase'",
              "computed": false
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "delimiterProps": {
      "defaultValue": {
        "value": "{\r\n  titleDelimiter: false,\r\n  position: 'left',\r\n  topMargin: '',\r\n  type: 'small',\r\n}",
        "computed": false
      },
      "description": "Attributes for the delimiter",
      "type": {
        "name": "shape",
        "value": {
          "titleDelimiter": {
            "name": "bool",
            "required": false
          },
          "position": {
            "name": "string",
            "required": false
          },
          "topMargin": {
            "name": "string",
            "required": false
          },
          "type": {
            "name": "enum",
            "value": [{
              "value": "'small'",
              "computed": false
            }, {
              "value": "'medium'",
              "computed": false
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "link": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "cta": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "captionPosition": {
      "defaultValue": {
        "value": "'bottom'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }, {
          "value": "'both'",
          "computed": false
        }]
      },
      "required": false
    },
    "contextualMenu": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "shape",
          "value": {}
        }, {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {}
          }
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "customTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};
var _default = Card;
exports["default"] = _default;